import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse, useUpdate } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { IHomepageCouponDetail, IHomepageCouponForm } from "interfaces";
import { HomepageCouponForm } from "./components";

export const EditHomepageCoupon: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const { mutate, isLoading: isUpdatingCoupon } = useUpdate();
  const navigate = useNavigate();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IHomepageCouponDetail>({
    resource: "mkt/coupon-homepages",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });


	const onSubmit = (values: IHomepageCouponForm) => {
    const submitValues = { ...values };
		const id = params?.id;
		if (id) {
			mutate(
				{
					resource: "mkt/coupon-homepages",
					id: id,
					meta: {
						ignoreResourceWrapper: true,
					},
					values: {
						...submitValues,
					},
				},
				{
					onSuccess: () => {
						toast.success("Edit successfully");
						navigate(`/mkt/homepage-coupon/${id}`);
					},
				}
			);	
		}
  };

  const homepageCouponDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Homepage Coupon" />
      {homepageCouponDetailData ? (
        <HomepageCouponForm
          defaultData={homepageCouponDetailData}
          id={params?.id}
					onSubmit={onSubmit}
        />
      ) : (
        <></>
      )}
      {((isFetching && isPreviousData) || isUpdatingCoupon) ? <FullScreenLoading /> : <></>}
    </div>
  );
};
